module.exports = "/_next/static/media/dff9d08c62dcccd8be81b36bac698e8e.png";